<template>
  <el-breadcrumb separator="/" style="margin-bottom:20px;">
    <el-breadcrumb-item><span style="cursor: pointer" @click="goback">列表</span></el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item,index) in route" :key="index">
      <template v-if="index === route.length-1">{{ item.name }}</template>
      <template v-else>
        <router-link :to="item.route">{{ item.name }}</router-link>
      </template>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  props: ['title', 'option', 'isBackToHome', 'projectId', 'routeName'],
  computed: {
    route() {
      if (this.option) {
        return option
      } else {
        return [{
          name: this.title
        }]
      }
    }
  },
  methods: {
    goback() {
      if (this.isBackToHome) {
        this.$router.push({name: 'home'})
      } else {
        // history.go(-1)
        this.$router.push({name: this.routeName, params: this.$route.params})
      }
    },
  }
}

</script>
